// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.custom-modal-width {\n  max-width: 80% !important; /* Adjust the max-width as needed */\n}\n.b-table th {\n  white-space: normal;\n  word-wrap: break-word; /* 确保长单词换行 */\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
